import React, { useState, useEffect } from "react";
import {
  IonButton,
  IonList,
  IonItem,
  IonLabel,
} from "@ionic/react";

const Pictographs: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [questions, setQuestions] = useState<any[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    const objects = [
        "🍎 Apples",
        "🍌 Bananas",
        "🍇 Grapes",
        "🍊 Oranges",
        "🚌 Buses",
        "🚲 Bicycles",
        "🐕 Dogs",
        "🐈 Cats",
        "🐦 Birds",
        "🐟 Fish",
        "🍓 Strawberries",
        "🥕 Carrots",
        "🍍 Pineapples",
        "🌽 Corn",
        "🍉 Watermelons",
        "🍋 Lemons",
    ];

    // Generate unique random data for the pictograph
    const generatePictographData = () => {
        const selectedObjects = [];
        const usedIndices = new Set<number>();
        const usedQuantities = new Set<number>();
    
        while (selectedObjects.length < 4) {
            const randomIndex = Math.floor(Math.random() * objects.length);
            const quantity = Math.floor(Math.random() * 9) + 1; // Quantity between 1 and 9
    
            if (
                !usedIndices.has(randomIndex) && // Ensure unique objects
                !usedQuantities.has(quantity) // Ensure unique quantities
            ) {
                const randomObject = objects[randomIndex];
                selectedObjects.push({ object: randomObject, quantity });
                usedIndices.add(randomIndex);
                usedQuantities.add(quantity);
            }
        }
        return selectedObjects;
    };

    // Generate dynamic questions based on the pictograph data
    const generateQuestions = (pictographData: any[]) => {
        const total = pictographData.reduce((acc, item) => acc + item.quantity, 0);
        const questionSet = [
            {
                question: `How many ${pictographData[0].object.split(" ")[1]} are represented?`,
                answer: pictographData[0].quantity,
            },
            {
                question: `How many ${pictographData[1].object.split(" ")[1]} are represented?`,
                answer: pictographData[1].quantity,
            },
            {
                question: `Which object has the highest quantity?`,
                answer: pictographData.reduce((max, item) =>
                item.quantity > max.quantity ? item : max
                ).object,
            },
            {
                question: `What is the total number of objects represented?`,
                answer: total,
            },
        ];

        return questionSet;
    };

    useEffect(() => {
        handleQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Data Handling - Pictographs"; // Set page title
    }, []);

    const handleQuestion = () => {
        // Generate new set of data and questions after finishing
        const newData = generatePictographData();
        setData(newData);
        setCurrentQuestionIndex(Math.floor(Math.random() * 3) + 1);
        setQuestions(generateQuestions(newData));
    };

    const handleAnswerSubmit = (userAnswer: any) => {
        setSelectedOption(userAnswer);
        const correctAnswer = questions[currentQuestionIndex].answer;
        if (userAnswer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                handleQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter additionWord">
                        <div>
                            <div className="mb-4">
                                {data.map((item, index) => (
                                <IonItem key={index}>
                                    <IonLabel>
                                        <strong>{item.object.split(" ")[1]}:</strong>{" "}
                                        <span style={{ fontSize: "20px" }}>
                                            {Array(item.quantity)
                                            .fill(item.object.split(" ")[0])
                                            .join(" ")}
                                        </span>
                                    </IonLabel>
                                </IonItem>
                                ))}
                            </div>
                            <div>
                                <h3>Question:</h3>
                                {questions.length > 0 && (
                                    <p>{questions[currentQuestionIndex].question}</p>
                                )}
                            </div>
                            <div className="row optionDiv">
                                {typeof questions[currentQuestionIndex]?.answer === "number" ? (
                                    [questions[currentQuestionIndex].answer - 1, questions[currentQuestionIndex].answer, questions[currentQuestionIndex].answer + 1]
                                        .sort(() => Math.random() - 0.5) // Shuffle options
                                        .map((option, index) => (
                                        <div className={`col optionButton ${
                                            selectedOption === option
                                                ? option === questions[currentQuestionIndex].answer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                        }`}
                                            key={index}
                                            onClick={() => handleAnswerSubmit(option)}
                                        >
                                            {option}
                                        </div>
                                        ))
                                    ) : (
                                    data.map((item, index) => (
                                        <div className={`col optionButton ${
                                            selectedOption === item.object
                                                ? item.object === questions[currentQuestionIndex].answer
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                        }`}
                                        key={index}
                                        onClick={() => handleAnswerSubmit(item.object)}
                                        >
                                            {item.object.split(" ")[0]}
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default Pictographs;
